import { render, staticRenderFns } from "./in-house-training.vue?vue&type=template&id=d9472a40"
import script from "./in-house-training.vue?vue&type=script&lang=js"
export * from "./in-house-training.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports